// announcement bar slide matchheight js
window.matchHeight = function (selector) {
  const elements = document.querySelectorAll(selector);

  function setEqualHeight() {
    if (!elements.length) return; // Ensure elements exist

    // Reset heights to auto for recalculation
    elements.forEach(element => {
      element.style.height = 'auto';
    });

    // Calculate the tallest element height
    const maxHeight = Array.from(elements).reduce((max, element) => {
      return Math.max(max, element.clientHeight);
    }, 0);

    // Apply the tallest height to all elements
    elements.forEach(element => {
      element.style.height = `${maxHeight}px`;
    });
  }

  function adjustOnResize() {
    // Debounce resize adjustments for performance
    clearTimeout(window.matchHeightTimeout);
    window.matchHeightTimeout = setTimeout(() => {
      requestAnimationFrame(setEqualHeight);
    }, 50);
  }

  // Set pre-calculated height during page load for smoother transition
  const preloadHeight = Array.from(elements).reduce((max, element) => {
    return Math.max(max, element.clientHeight || 0);
  }, 0);
  if (preloadHeight) {
    elements.forEach(element => {
      element.style.height = `${preloadHeight}px`;
    });
  }

  // Run on window load
  // window.addEventListener('load', setEqualHeight);
// Run the function after a delay when the page loads
// window.addEventListener('load', () => {
//   setTimeout(setEqualHeight, 50); // Delay of 100ms
// });

  // Run on window resize
  window.addEventListener('resize', adjustOnResize);
};

// // Call the function for your specific selector
// window.matchHeight('.announcement .text-wrap_main');

/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      var variantSku = variant.sku;
      var skuElement = document.querySelector('.product__block__sku');
  
      if (skuElement) {
        if (variantSku) {
          skuElement.innerText = 'SKU: ' + variantSku;
        } else {
          skuElement.innerText = '';
        }
      }
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();



// Cart page Footer structure
if (window.location.href.includes('cart')) {
   const checkDiv = setInterval(() => {
      if(document.querySelectorAll('div[data-cart-page-upsell-wrapper]').length > 0) {
          
        document.querySelector('.template__cart__footer').classList.add('footer-upsell');
        
      } 
    }, 100); 
 }

document.addEventListener('DOMContentLoaded', function() {
  document.querySelector('.checkout__button').addEventListener('click', function(event) {
    // Get the value of the terms checkbox
    var termsCondition = document.querySelector('#terms_condition').checked;

    // Initialize a flag to track validation status
    var isValid = true;

    // Clear previous error messages
    var errorMessages = document.querySelectorAll('.error-message');
    errorMessages.forEach(function(message) {
      message.remove();
    });
    
    // Check if terms and conditions checkbox is not checked
    if (!termsCondition) {
      isValid = false;
      // Display error message for terms and conditions
      var termsElement = document.querySelector('.terms_condition_checkbox');
      var termsConditionElement = document.querySelector('#terms_condition');
      var termsConditionError = document.createElement('span');
      termsConditionError.className = 'error-message';
      termsConditionError.textContent = 'You must agree to the terms and conditions.';
      termsElement.appendChild(termsConditionError);
    }

    // If any validation fails, prevent the default action (redirect)
    if (!isValid) {
      event.preventDefault();
    }
  });
});




//JavaScript for the Lightbox on the PDP
document.body.addEventListener("click", function(e){

    if(e.target.closest(".pswp__button--close")){
        e.target.closest(".pswp__button--close").click();
    }

  if(e.target.closest(".pswp__button--arrow--left")){
        e.target.closest(".pswp__button--arrow--left").click();
    }
      if(e.target.closest(".pswp__button--arrow--right")){
        e.target.closest(".pswp__button--arrow--right").click();
    }
        
})



/* REBUY SNIPPETS */
/*
document.querySelector('.navlink.navlink--cart').addEventListener('click', () => {
  Rebuy.SmartCart.show();
});

document.querySelector('#drawer-cart .drawer__button.drawer__close').click();
*/




